import NextLink from 'next/link';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { Role, Routes } from '../../types';
import { userRoleIsAtLeast } from '../../helpers/roles';
import { useContext } from 'react';
import { AuthContext } from '../../providers/MPAuthContextProvider';
interface mainLinksProps {
  isRestricted?: boolean;
  pathname: string;
  role: string;
  query?: any;
}
export const mainLinks = ({
  pathname,
  role,
  query,
  isRestricted = false
}: mainLinksProps) => {
  const {
    auth
  } = useContext(AuthContext);
  if (!auth) {
    return [];
  }
  const canManage = userRoleIsAtLeast({
    userRole: role,
    requiredRole: auth?.entityId == 2689 ? Role.TeamAdmin : Role.TeamManager
  });
  const hasInsights = userRoleIsAtLeast({
    userRole: role,
    requiredRole: Role.TeamAmbassador
  });
  const links = [{
    label: 'Insights',
    href: Routes.ROIDashboard,
    isActive: pathname === Routes.ROIDashboard,
    isExternal: false,
    isManager: true,
    hasPermission: hasInsights
  }, {
    label: 'Newsfeed',
    href: '/newsfeed/global',
    isActive: pathname === Routes.Newsfeed,
    isExternal: false,
    isManager: false,
    hasPermission: true
  }, {
    label: 'Games',
    isActive: pathname === Routes.Games || pathname === Routes.Stats,
    hasPermission: true,
    isManager: false,
    subLinks: [{
      as: NextLink,
      label: 'Game Center',
      href: Routes.Games,
      isActive: pathname === Routes.Games
    }, {
      as: NextLink,
      label: 'Game Guides',
      href: Routes.Guides,
      isActive: pathname === Routes.Guides
    }, {
      as: NextLink,
      label: 'My Stats',
      href: Routes.Stats,
      isActive: pathname === Routes.Stats
    }]
  }, {
    label: 'Rewards',
    isActive: pathname === Routes.Rewards || pathname === Routes.RewardsActivity,
    hasPermission: true,
    isManager: false,
    subLinks: isRestricted ? [{
      as: NextLink,
      label: 'Activity',
      href: Routes.RewardsActivity,
      isActive: pathname === Routes.RewardsActivity && query?.filter != 'reward_purchases',
      icon: <ICON_BY_NAME.tokenhistory width="15px" height="16px" />
    }] : [{
      as: NextLink,
      label: 'Shop',
      href: Routes.Rewards,
      isActive: pathname === Routes.Rewards,
      icon: <ICON_BY_NAME.store width="15px" height="15px" />
    }, {
      as: NextLink,
      label: 'Purchases',
      href: Routes.RewardsPurchases,
      isActive: pathname === Routes.RewardsActivity && query?.filter == 'reward_purchases',
      icon: <ICON_BY_NAME.giftone width="15px" height="16px" />
    }, {
      as: NextLink,
      label: 'Activity',
      href: Routes.RewardsActivity,
      isActive: pathname === Routes.RewardsActivity && query?.filter != 'reward_purchases',
      icon: <ICON_BY_NAME.tokenhistory width="15px" height="16px" />
    }]
  }, {
    label: 'Learners',
    isActive: pathname === Routes.ProfileId || pathname === Routes.Players,
    hasPermission: true,
    isManager: false,
    subLinks: [{
      as: NextLink,
      label: 'My Profile',
      href: Routes.Profile,
      isActive: pathname === Routes.Profile,
      icon: <ICON_BY_NAME.profile width="15px" height="15px" />
    }, {
      as: NextLink,
      label: 'Learner Directory',
      href: Routes.Players,
      isActive: pathname === Routes.Players,
      icon: <ICON_BY_NAME.directory width="15px" height="15px" />
    }]
  }, {
    label: 'Manage',
    href: canManage ? Routes.ManagePlayers : Routes.Manage,
    isActive: pathname.includes(Routes.Manage),
    isExternal: false,
    isManager: true,
    hasPermission: canManage
  }];
  return links.filter(link => link.hasPermission);
};